import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ToggleFiltersOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    filtersOpen: state.pages.orderHistory.filtersOpen,
});

const mapDispatchToProps = {
    toggleFiltersOpen,
};

export interface OrderHistorySearchFormStyles {
    wrapper?: InjectableCss;
    filterOverlay?: InjectableCss;
    headingText?: TypographyPresentationProps;
    closeContainer?: InjectableCss;
}

export const searchFormStyles: OrderHistorySearchFormStyles = {
    wrapper: {
        css: css`
            margin-bottom: 10px;
            width: 474px;
            border: 1px solid rgba(7,15,44,0.08);
            border-radius: 1px;
            background-color: #fff;
            position: absolute;
            z-index: 99;
            padding: 90px 35px 50px 35px;
            left: 288px;
            top: -160px; 

            div[data-test-selector="filter-search"] {
                position: relative;
                padding: 0;

                span[class*='IconWrapper']:not(.search-icon),
                span[class^='IconWrapper']:not(.search-icon) {
                    display: none;
                }

                div[role="combobox"] {
                    padding: 0;
                }

                input[role="searchbox"] {
                    padding-right: 45px;
                }

                ul[role="listbox"]:empty {
                    display: none;
                }

                // &.no-options-present {
                //     ul[role="listbox"] {
                //         display: none;
                //     }
                // }

                // [data-id="no-options"] {
                //     display: none;
                // }

                .search-icon {
                    position: absolute;
                    right: 15px;
                    top: 14px;
                }

                @media screen and (max-width: 1280px) {
                    .search-icon {
                        right: 15px;
                        top: 41px;
                    }
                }


            }

            > div:last-child {
                > div {
                    padding: 0;
                }
            }
            > div > div > div {
                flex-direction: column;

                > div {
                    max-width: 100%;
                    flex-basis: 100%;

                    > div > div {
                        padding: 5px 0;
                    }
                }

                label {
                    color: #002554;
                    font-family: 'Roboto', sans-serif;
                    font-size: 15px;
                    font-weight: 500;
                    letter-spacing: 0.17px;
                    line-height: 30px;
                    display: inline-flex;
                    min-width: 94px;
                    max-width: 94px;
                    align-items: center;
                }

                label[data-test-selector="orderHistory_filterToDate-label"] {
                    min-width: 26px;
                    max-width: 26px;
                    margin-left: 12px;
                    word-break: normal;
                }

                .react-datetime-picker__inputGroup__leadingZero {
                    margin: -1px 0px 0 3px
                }

                input:not(.react-datetime-picker__inputGroup__input), 
                select:not(.react-datetime-picker__inputGroup__input), 
                textarea, 
                .mobiusFileUpload, 
                .react-datetime-picker,
                input {
                    border-color: rgba(31,96,172,0.5) !important;
                    border-radius: 2px !important;
                    background-color: #fff !important;
                    color: #535E64 !important;
                }

                .react-datetime-picker {
                    padding-left: 5px !important;
                    min-width: 135px;
                }
                .react-datetime-picker__inputGroup {
                    padding-left: 1px !important;
                }

                .react-datetime-picker__calendar-button {
                    svg {
                        height: 18px;
                        width: 18px;
                    }

                    &:focus {
                        span {
                            outline: none;
                        }
                    }
                }

                [class*="FormInputWrapper"] {
                    margin-top: 0 !important;
                }
               
            }

            div[data-test-selector="orderHistory_filterDateRange"] {
                [class*="FormFieldStyle"],
                [class*="FormInputWrapper"] {
                    padding: 0 !important;
                }
            }

            @media screen and (min-width: 1280px) {
                &:before {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    border-top: 30px solid transparent;
                    border-bottom: 30px solid transparent;
                    border-right: 30px solid #fff;
                    left: -25px;
                    top: 215px;
                }

                > div > div > div {
                    [class*="FormFieldStyle"] {
                        flex-direction: row;
                        padding: 5px 0 !important;
                    }
                }

                .react-datetime-picker {
                    max-width: 127px;
                }

                div[data-test-selector="orderHistory_filterDateRange"] {
                    [class*="DescriptionWrapper"] {
                        display: none;
                    }
                }
            }

            @media screen and (min-width: 1280px) {
                > div > div > div {
                    flex-direction: row;
                    padding: 5px 0;

                    &:last-child {
                        flex-direction: column;
                        padding-top: 25px;
                    }
                }
            }

            @media screen and (max-width: 1279px) {
                z-index: 99;
                left: 0;
                top: -183px;
                width: 100%;
                padding: 70px 15px 50px 15px;

                > div > div > div[data-test-selector="orderHistory_filterDateRange"] {
                    flex-direction: row;

                    [class*="FormInputWrapper"] {
                        padding-top: 0;
                        margin-bottom: 5px;
                    }
                }

                > div > div > div {
                    label[data-test-selector="orderHistory_filterToDate-label"] {
                        margin-left: 0;
                    }

                    [class*="FormInputWrapper"] {
                        margin-bottom: 10px;
                    }

                    [class*="FormFieldStyle"] {
                        padding: 5px 0 !important;
                    }
                }

                div[data-test-selector="orderHistory_filterDateRange"] > div {
                    margin-right: 25px;
                    max-width: min-content;
                }
            }
        `,
    },
    filterOverlay: {
        css: css`
            position: absolute;
            z-index: 2;
            opacity: 0.32;
            background-color: #002554;
            top: -53px;
            left: 0;
            width: 100%;
            height: 104%;
        `,
    },
    headingText: { 
        variant: "h5",
        css: css`
            position: relative;
            font-size: 18px;
            font-weight: 500;
            &:after {
                height: 0.125rem;
                width: 2.5rem;
                background-color: rgb(198,53,39);
                content: "";
                display: inline-block;
                position: absolute;
                bottom: -0.25rem;
                left: 1px;
            }
        `,
    },
    closeContainer: {
        css: css`
           position: absolute;
           right: 2.25rem;
           top: 24px;
           cursor: pointer;
           .close-label {
                color: #333F48;
                font-family: Roboto;
                font-size: .875rem;
                letter-spacing: 0;
                line-height: 1;
                display: inline-block;
                margin-right: .625rem;
                vertical-align: middle;
           }
           .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1.125rem;
                height: 1.125rem;
                svg {
                    height: 1.125rem;
                    width: 1.125rem;
                    color: #868686;
                }
            }
            @media screen and (max-width: 1279px) {
                right: 1.25rem;
            }
        `,
    },
};

const styles = searchFormStyles;

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ResolveThunks<typeof mapDispatchToProps>;

const OrderHistorySearchForm: React.FunctionComponent<Props> =  (props) => {
    if (!props.filtersOpen) {
        return <Zone contentId={props.id} zoneName="Content01" />;
    }

    return (
        <>  
            <Zone contentId={props.id} zoneName="Content01" />
            <StyledWrapper {...styles.wrapper}>
            <Typography as="div" onClick={() => props.toggleFiltersOpen()} {...styles.closeContainer}>
                <span className="close-label">Close filters</span>
                <Icon className="icon-close" src="XCircle"/>
            </Typography>
                <Typography as="h3" {...styles.headingText}>
                    {translate("Filter Orders")}
                </Typography>
                <Zone contentId={props.id} zoneName="Content" />
            </StyledWrapper>
            <Typography as="div" {...styles.filterOverlay} onClick={() => props.toggleFiltersOpen()} className="filter-overlay"></Typography>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchForm),
    definition: {
        group: "Order History", 
        displayName: "Filter Header",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};


export default widgetModule;
